import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router";
import InfiniteScrollComponent from "../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import {
  getAllProgramsActionHandler,
  getShotClassesActionHandler,
} from "../../../store/actions/actionHandlers/distributeActionHandler";
import DistributeCollectionList from "./DistributeCollectionList";
import classes from "./DistributeCollection.module.scss";
import BoxLayout from "../../../components/Common/BoxLayout/BoxLayout";
import {
  setCollectionDataAction,
  setSelectedCollectionDataAction,
} from "../../../store/actions/actionCreators/distributeActionCreator";
import DistributeFooter from "../DistributeFooter/DistributeFooter";

const DistributeCollection = () => {
  const dispatch = useDispatch();
  const pageSize = 9;
  const { collectionCount, setCollectionCount, tenantName } =
    useOutletContext();
  const distributeState = useSelector((state) => state.distributeReducer);
  const {
    selctedCollectionData,
    collectionData,
    selctedShotclassData,
    selctedSeriesData,
  } = distributeState;
  const [pageNum, setPageNum] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [deleteCollectionData, setDeleteCollectionData] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    if (deleteCollectionData) {
      dispatch(setCollectionDataAction([]));
      dispatch(
        getShotClassesActionHandler(
          "WithoutVTLT",
          false,
          "Published",
          "Collection",
          "none",
          "none",
          1,
          pageSize
        )
      );
      setDeleteModal(false);
      dispatch(
        getAllProgramsActionHandler(
          "WithoutVTLT",
          "Published",
          "Collection",
          setCollectionCount
        )
      );
      setDeleteCollectionData(null);
    }
  }, [deleteCollectionData, dispatch, setCollectionCount]);

  useEffect(() => {
    if (pageNum > 1)
      dispatch(
        getShotClassesActionHandler(
          "WithoutVTLT",
          false,
          "Published",
          "Collection",
          "none",
          "none",
          pageNum,
          pageSize
        )
      );
  }, [dispatch, pageNum]);

  const fetchMoreData = () => {
    if (collectionData?.length >= collectionCount) {
      setHasMoreData(false);
      return;
    }
    setPageNum((prevState) => prevState + 1);
  };

  const handleCheckboxChange = (e, data) => {
    if (e?.target?.checked) {
      dispatch(
        setSelectedCollectionDataAction([...selctedCollectionData, data])
      );
      const updatedData = collectionData?.map((item) => {
        return {
          ...item,
          Collection: {
            ...item.Collection,
            checked:
              data?.ID === item?.Collection?.ID || item?.Collection?.checked
                ? true
                : false,
          },
        };
      });
      dispatch(setCollectionDataAction(updatedData));
    } else {
      const updatedData = selctedCollectionData?.filter((item) => {
        return item?.ID !== data?.ID;
      });
      dispatch(setSelectedCollectionDataAction(updatedData));
      const selectedpdatedData = collectionData?.map((item) => {
        return {
          ...item,
          Collection: {
            ...item.Collection,
            checked:
              data?.ID === item?.Collection?.ID && item?.Collection?.checked
                ? false
                : item?.Collection?.checked
                ? true
                : false,
          },
        };
      });
      dispatch(setCollectionDataAction(selectedpdatedData));
    }
  };

  return (
    <BoxLayout>
      {collectionCount > pageSize && (
        <InfiniteScrollComponent
          dataLength={collectionData?.length ? collectionData.length : pageSize}
          fetchMoreData={fetchMoreData}
          hasMoreData={hasMoreData}
          height={collectionData?.length > 0 ? "100vh" : "20vh"}
          loader={true}
        >
          <DistributeCollectionList
            collectionData={collectionData}
            setDeleteCollectionData={setDeleteCollectionData}
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            handleCheckboxChange={handleCheckboxChange}
          />
        </InfiniteScrollComponent>
      )}
      {collectionCount === 0 && (
        <div className={classes.collectionNotFoundText}>
          No Collection Found
        </div>
      )}
      {collectionCount <= pageSize && (
        <DistributeCollectionList
          collectionData={collectionData}
          setDeleteCollectionData={setDeleteCollectionData}
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          handleCheckboxChange={handleCheckboxChange}
        />
      )}
      {(selctedShotclassData?.length > 0 ||
        selctedSeriesData?.length > 0 ||
        selctedCollectionData?.length > 0) && (
        <DistributeFooter tenantName={tenantName} />
      )}
    </BoxLayout>
  );
};

export default DistributeCollection;
